import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { arrayAny } from "../../utils/arrayUtils";

export const MetaDataTable = (props) => {

    const humanizeDate = (d, format) => {

        switch (format) {
            case "relative":
                return DateTime.fromISO(d).toRelativeCalendar();

            default:
                const dt = DateTime.fromISO(d);
                return `${dt.toFormat("dd MMM yyyy HH:mm:ss")} (UTC ${dt.toFormat("Z")})`;
        }

    }

    const createdByReady = () => (props && props.data && props.data.createdBy && props.data.createdBy.id);
    const modifiedByReady = () => (props && props.data && props.data.modifiedBy && props.data.modifiedBy.id);

    return props && arrayAny(Object.keys(props.data)) && (
        <>
            <hr />
            <div className="d-flex flex-row align-items-center justify-content-between fw-bolder">
                <div className="flex-grow-0 fs-12px me-2 text-dark">
                    Created By
                </div>
                <div className="flex-grow-0 fs-12px me-2 text-dark">
                    Created
                </div>
                <div className="flex-grow-0 fs-12px me-2 text-dark">
                    Modified By
                </div>
                <div className="flex-grow-0 fs-12px me-2 text-dark">
                    Modified
                </div>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-between">

                <div style={{ textTransform: "capitalize" }} title={props.data.createdBy.userName} className="flex-grow-0 fs-12px me-2 text-dark">
                    {createdByReady() ? <Link to={`/user/${props.data.createdBy.id}`}>{props.data.createdBy.displayName}</Link>
                    :
                    <>{props.data.createdBy.displayName}</>
                    }
                    
                </div>
                <div style={{ textTransform: "capitalize" }} title={humanizeDate(props.data.created)} className="flex-grow-0 fs-12px me-2 text-dark">
                    {humanizeDate(props.data.created, "relative")}
                </div>
                <div style={{ textTransform: "capitalize" }} title={props.data.modifiedBy.userName} className="flex-grow-0 fs-12px me-2 text-dark">
                    {modifiedByReady() ? <Link to={`/user/${props.data.modifiedBy.id}`}>{props.data.modifiedBy.displayName}</Link>
                    :
                    <>{props.data.modifiedBy.displayName}</>
                    }
                </div>
                <div style={{ textTransform: "capitalize" }} title={humanizeDate(props.data.modified)} className="flex-grow-0 fs-12px me-2 text-dark">
                    {humanizeDate(props.data.modified, "relative")}
                </div>
            </div>
            <hr />
        </>
    );
}